module.exports = __webpack_public_path__ + "media/images/signup-handshake-09afcef97544a14ae56183ba50e05b57.svg";